<template>
  <div id="app" style="height:100%">
    <router-view/>
  </div>
</template>
<style>
  @import "./common/font/font.css";
</style>
<script>
export default {
  name: 'App'

}
</script>



// WEBPACK FOOTER //
// src/App.vue